import React, { useEffect } from "react";
import Banner from "../Components/Career/Banner";
import DetailsCareer from "../Components/Career/DetailsCareer";
import { useNavigate, useParams } from "react-router-dom";
import { useCareers } from "../Context/CareersContext";
import { usePagesBanners } from "../Context/PagesBannersContext";

function Career() {
  const { id } = useParams();
  const { isBanner } = usePagesBanners();
  const { getCareerById, isCareerById } = useCareers();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      await getCareerById(id); // Fetch project data when the component is mounted
    };

    fetchData();
    window.scrollTo({ top: 0, behavior: "auto" }); // Scroll to top on load
  }, [id]);

  if (isCareerById === null) {
    navigate(`/NotFound`, { replace: true }); // Redirect if there's no data
    return null; // Don't render anything while navigating
  }

  return (
    <div className="flex flex-col mx-[2rem] lg:mx-[7rem] md:mx-[4rem] gap-7 overlay">
      <Banner isCareerById={isCareerById?.data?.title} isBanner={isBanner?.data[5]}/>
      <DetailsCareer isCareerById={isCareerById} />
    </div>
  );
}

export default Career;
